import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import { Button, LinearProgress } from '@mui/material'
import { H3 } from '../../../layouts/TextStyles'
import { courseApiSlice } from '../../../features/course/courseSlice'
import CoursesExamsTable from './components/CoursesExamsTable'
import { ui } from '../../../utils/uiTokens'

const ExamsPage = () => {
    const { formatMessage } = useIntl()
    const { data: courses = [], isFetching } =
        courseApiSlice.useFetchAllCoursesQuery()



    return (
        <Wrapper>
            <Content>
                <Header>
                    <Title>
                        <H3>{formatMessage({ id: 'courses' })}</H3>
                    </Title>
                </Header>

                {isFetching && <LinearProgress />}

                {courses && (
                    <CoursesExamsTable
                        coursesData={courses}
                    />
                )}
            </Content>
        </Wrapper>
    )
}

export default ExamsPage

const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`

const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

const Content = styled.div`
    background-color: ${ui.card};
    border-radius: 16px;
    padding: 20px;
    min-height: 80vh;
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
